import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import domClass from 'dojo/dom-class';
import domConstruct from 'dojo/dom-construct';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
// Non-dojo dep from the original define() not referenced as a value in code — kept as a
// side-effect import so the AMD loader still preloads it (faithful to the original deps).
import "../../../moreCore/UI/GenericDialog/GenericDialog";
import template from './CateringBookingTable.html?raw';
// NOTE (JS2TS): dropped dead deps (imported in the original define() but unused in code &
// template): dojo/_base/connect, dojo/_base/array, dojo/_base/Color, dojo/date/locale,
// dojo/keys, dijit/_WidgetBase, dijit/_TemplatedMixin, dijit/_WidgetsInTemplateMixin,
// dijit/registry, dojo/on, dojo/dom-attr, dojo/dom-style.

class CateringBookingTable extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    data: any = null;
    layout: any = null;
    mode = "daily"; // "summary"
    table: any = null;


    setData(entitylist: any, layout: any) {
        this.data = entitylist;
        if (layout) {
            this.layout = layout;
        }
        this.drawTable();
    }

    _tableFormatter(tableCell: any) {
        let node = tableCell.contentnode;
        let entity = tableCell.entity;
        let colName = tableCell.name;
        let value = tableCell.value;

        //console.debug("_tableFormatter", tableCell);

        let dateFormat_ddMMyyyy_HHmm: any = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
        let dateFormat_HHmm: any = { hour: '2-digit', minute: '2-digit' };
        let dateFormat_ddMMyyyy: any = { year: 'numeric', month: '2-digit', day: '2-digit'/*, hour: '2-digit', minute: '2-digit'*/ };
        let dateFormat_dddd_ddMMyyyy: any = { year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'long'/*, hour: '2-digit', minute: '2-digit'*/ };


        switch (colName) {
            case "dateStart":
                // BEISPIEL!!
                let date = new Date(entity.date_start);//dojoDate.parse(value, { datePattern: "yyyy-MM-dd", selector: "date" });

                let weekDay = date.toLocaleDateString('de-DE', dateFormat_dddd_ddMMyyyy);

                node.innerHTML = weekDay;
                return true;
                break;

            case "booker":
                if (entity.ref_booker) {
                    if (entity.ref_booker.ID == this.getCurrentEmployeeId()) {
                        value = "DAS BIN ICH!";
                    }
                }
                    node.innerHTML = value;
                return true;
                break;
            default:
                if (value == null || value == "" || typeof value == "undefined") value = "N.A.";
                node.innerHTML = value;
        }
    }

    drawTable(data?: any, layout?: any) {
        if (data) {
            this.setData(data, layout);
        } else {
            data = this.data;
        }

        domConstruct.empty(this.tableContainer);

        if (!this.layout) {
            this.tableContainer.innerHTML = "no layout!";
            return;
        }

        domClass.add(this.emptyResultsContainer, "w3-hide");
        domClass.add(this.tableContainer, "w3-hide");

        if (!data || !data.length) {
            domClass.remove(this.emptyResultsContainer, "w3-hide");
            return;
        }

        this.table = new StaticTable();
        this.table.setFormatter(lang.hitch(this, this._tableFormatter));
        this.table.setTableLayout(this.layout);
        this.table.setData(this.data);

        this.table.setRowClick(lang.hitch(this, this._onRowclick));

        this.table.placeAt(this.tableContainer);

        domClass.remove(this.tableContainer, "w3-hide");
    }

    _onRowclick(tableRow: any) {
        console.debug("_onRowclick", tableRow);
        this.emit("rowclick", tableRow.rowGroup.entity.ID);
    }

    postMixInProperties() {
        super.postMixInProperties.apply(this, arguments as any); // standard code aus basisklasse

    }
    postCreate() {
        super.postCreate.apply(this, arguments as any);
    }

    startup() {
        super.startup.apply(this, arguments as any);

    }
    destroy() {
        super.destroy.apply(this, arguments as any);
    }


}
CateringBookingTable.prototype.declaredClass = 'WidgetCollection.JDM.CateringBooking.CateringBookingTable';

export default mdsWidget(CateringBookingTable);
